import { createTypedHooks } from 'easy-peasy'
import { Model } from './models'

const typedHooks = createTypedHooks<Model>()

export const { useStoreActions, useStoreDispatch, useStoreState } = typedHooks
